<div class="main-container">
    <nav class="navbar navbar-light">
        <div><a href="#"><img src="../../../../../assets/img/LOGO_XPIndia_Square.png" width="20%" alt=""></a></div>
    </nav>
    <div class="content">
        <!-- <div class="d-flex justify-content-between align-items-center"> -->
            <div class="navbtn d-flex justify-content-end mb-2">
                <button mat-raised-button class="mr-2" style="background-color: #286ba5;color: white;" (click)="ShareDialog()">
                    Share
                    <mat-icon>share</mat-icon>
                </button>                  
                <button mat-raised-button style="background-color: #286ba5;color: white;" (click)="back()">
                    Back
                    <mat-icon>keyboard_backspace</mat-icon>
                </button>
            <!-- </div> -->
        </div>
        <div class="container mt-3 processBar"
            style="display: flex; flex-direction: column; align-items: center; position: relative;">
            <mat-icon [ngClass]="{'progress-bar-icon': FIRST_MILE}"
                style="position: absolute; left: 0%; top: 50%; transform: translate(-50%, -50%);">
                check_circle
            </mat-icon><span
                style="position: absolute; left: 0%; transform: translateX(-50%);bottom: -30px;">Ordered</span>

            <mat-progress-bar mode="buffer" [value]="progressValue" style="width: 100%;"></mat-progress-bar>

            <mat-icon [ngClass]="{'progress-bar-icon': FIRST_MILE && MIDDLE_MILE}"
                style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
                brightness_1
            </mat-icon><span
                style="position: absolute; left: 50%; transform: translateX(-50%);bottom: -30px;">InTransit</span>

            <mat-icon [ngClass]="{'progress-bar-icon': FIRST_MILE && MIDDLE_MILE && LAST_MILE}"
                style="position: absolute; left: 100%; top: 50%; transform: translate(-50%, -50%);">
                check_circle
            </mat-icon><span
                style="position: absolute; left: 100%; transform: translateX(-50%);bottom: -30px;">Delivered</span>
        </div>

        <div class="detail-box">
            <h1 class="text-center">Order Details</h1>
            <div class="content-container">
                <mat-card class="card-wrapper">
                    <div class="row">
                        <!-- Map Area -->
                        <div class="col map-area" [ngClass]="{ 'hide-map': details?.DeliveredDestination != null }">
                            <mat-card>
                                <app-map [latitude]="latitude" [longitude]="longitude" [location]="location"></app-map>
                            </mat-card>
                        </div>

                        <!-- Order Details -->
                        <div class="col order-details">
                            <table class="table">
                                <tbody>
                                    <tr>
                                        <th>Order ID</th>
                                        <td>{{details.OrderId}}</td>
                                    </tr>
                                    <tr>
                                        <th>Status of the Order</th>
                                        <td>{{details.StatusOfOrder}}</td>
                                    </tr>
                                    <tr>
                                        <th>XPCN / XPLS Number</th>
                                        <td>{{details.XPCN}}</td>
                                    </tr>
                                    <tr>
                                        <th>From</th>
                                        <td>{{details.From}}</td>
                                    </tr>
                                    <tr>
                                        <th>To</th>
                                        <td>{{details.To}}</td>
                                    </tr>
                                    <tr>
                                        <th>Via Points</th>
                                        <td>{{details.ViaPoints}}</td>
                                    </tr>
                                    <tr>
                                        <th *ngIf="details.order_type == 'FCL'">Departure Date</th>
                                        <th *ngIf="details.order_type == 'LCL'">Picked Date</th>
                                        <td>
                                            {{ 
                                                details.IsTripClosed 
                                                    ? (details.DepartedOrigin | date: details.order_type == 'LCL' ? 'dd-MM-y' : 'dd-MM-y, HH:mm') 
                                                    : (details.DepartedOrigin | date: details.order_type == 'LCL' ? 'dd-MM-y' : 'dd-MM-y, HH:mm') 
                                            }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th *ngIf="details.order_type == 'FCL'">
                                            {{ details.IsTripClosed ? 'Delivery Date' : 'ETA' }}
                                        </th>
                                        <th *ngIf="details.order_type == 'LCL'">
                                            {{ details.IsTripClosed ? 'Delivery Date' : 'EDD' }}
                                        </th>
                                        <td>
                                            {{ 
                                                details.IsTripClosed 
                                                    ? (details.DeliveredDestination | date: details.order_type == 'LCL' ? 'dd-MM-y' : 'dd-MM-y, HH:mm') 
                                                    : (details.ETA | date: details.order_type == 'LCL' ? 'dd-MM-y' : 'dd-MM-y, HH:mm') 
                                            }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        
                    </div>

                    
                </mat-card>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>